import type { InfoPageId } from '../../content/infoPages';
import { navigate } from '../../hooks/useHashRoute';
import { SearchBox } from '../ui/SearchBox';
import { ThemeSwitcher } from '../ui/ThemeSwitcher';
import { SiteMenu } from './SiteMenu';

interface AppHeaderProps {
  connectionLabel?: string;
  currentSymbol?: string;
  currentPage?: InfoPageId;
}

export function AppHeader({ connectionLabel = 'Public market data', currentSymbol, currentPage }: AppHeaderProps): React.JSX.Element {
  return (
    <header className="app-header">
      <button className="brand" type="button" onClick={() => navigate('/')} aria-label="Open opportunity tables">
        <span className="brand-mark">P</span>
        <span className="brand-copy">
          <strong>Pilum Trade Lab</strong>
          <span>Adaptive opportunity intelligence</span>
        </span>
      </button>
      <SearchBox initialValue={currentSymbol?.replace(/USDT$/, '') ?? ''} />
      <div className="header-actions">
        <span className="status-pill" title={connectionLabel}>
          <span className="status-dot" />
          {connectionLabel}
        </span>
        <SiteMenu currentPage={currentPage} />
        <ThemeSwitcher />
      </div>
    </header>
  );
}
